import React from "react";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import { get } from "../../common/apiClient";

const MailViewer = ({ mailbox, message, onDelete }) => {
  const { t } = useTranslation();

  if (!message) {
    return (
      <div className="h-full flex flex-col items-center justify-center text-center text-gray-400">
        <div className="w-24 h-24 mb-4 rounded-full bg-gray-100" />
        <div className="text-sm font-medium">{t("noMessageSelected")}</div>
      </div>
    );
  }

  const handleDownload = async (attachment) => {
    if (!mailbox) return;
    const url = `/attachments/${attachment.id}/download?mailboxId=${mailbox.id}`;
    const fullUrl =
      (process.env.REACT_APP_API_URL || "http://localhost:4000") + "/api" + url;
    window.open(fullUrl, "_blank");
  };

  return (
    <div className="flex flex-col h-full">
      <div className="px-4 py-3 border-b border-gray-200">
        <div className="text-base font-semibold text-gray-900 mb-1">
          {message.subject || "(no subject)"}
        </div>
        <div className="text-xs text-gray-600">
          <div>
            <span className="font-semibold">{t("from")}:</span>{" "}
            <span>{message.from}</span>
          </div>
          <div>
            <span className="font-semibold">{t("to")}:</span>{" "}
            <span>{message.to}</span>
          </div>
        </div>
      </div>
      {message.attachments && message.attachments.length > 0 && (
        <div className="px-4 py-2 border-b border-gray-200 flex items-center justify-between">
          <div className="text-xs font-semibold text-gray-700">
            {t("attachments")}
          </div>
          <div className="flex flex-wrap gap-2">
            {message.attachments.map((att) => (
              <button
                key={att.id}
                type="button"
                onClick={() => handleDownload(att)}
                className="text-xs px-2 py-1 rounded border border-gray-300 hover:bg-gray-100"
              >
                {att.filename}
              </button>
            ))}
          </div>
        </div>
      )}
      <div className="flex-1 overflow-auto px-4 py-3 bg-gray-50">
        {message.html ? (
          <div
            className="prose prose-sm max-w-none"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(message.html),
            }}
          />
        ) : (
          <pre className="text-xs text-gray-800 whitespace-pre-wrap">
            {message.text}
          </pre>
        )}
      </div>
      <div className="px-4 py-2 border-t border-gray-200 flex justify-end">
        <button
          type="button"
          onClick={onDelete}
          className="text-xs px-3 py-1.5 rounded bg-red-500 text-white hover:bg-red-600"
        >
          {t("delete")}
        </button>
      </div>
    </div>
  );
};

export default MailViewer;

